// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.oxalus",
    name: "Oxalus Wallet",
    homepage: "https://oxalus.io/wallet",
    image_id: "a6e22fcb-6b69-45d2-b52d-a4a347a21e00",
    app: {
        browser: "https://oxalus.io/",
        ios: "https://apps.apple.com/vn/app/oxalus-wallet/id1620111723",
        android: "https://play.google.com/store/apps/details?id=io.oxalus.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "oxalus://",
        universal: "https://oxalus.page.link/?apn=io.oxalus.wallet&isi=1620111723&ibi=io.oxalus.wallet&link=https://deeplink.oxalus.io",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map